module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-dorm-large-828cf8af6873de3a6ad62fa0e2b7e7d7.jpg";